var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"inset":"","dense":"","hide-details":"auto","input-value":_vm.value,"readonly":_vm.readOnly},on:{"change":function($event){_vm.$emit('input', Boolean($event)),
        _vm.$emit('change', Boolean($event)),
        _vm.$emit('blur'),
        _vm.$emit('focus')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }